package com.imobly.imobly.api.httpclient

import com.imobly.imobly.api.dto.ErrorDTO
import com.imobly.imobly.api.dto.Ok
import com.imobly.imobly.api.dto.StatusInstallmentDTO
import com.imobly.imobly.api.dto.ResponseMessage
import com.imobly.imobly.api.getToken
import com.imobly.imobly.domain.Payment
import com.imobly.imobly.domain.enums.PaymentStatusEnum
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.request.header
import io.ktor.client.request.patch
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.contentType
import io.ktor.http.isSuccess

class PaymentHttpClient(val httpClient: HttpClient) {
    val baseUrl = "/pagamentos"

    suspend fun searchByLeaseId(id: String, page: Int = 0, status: PaymentStatusEnum? = null): Payment {
        val statusParam = if (status != null) "&status=${status.name}" else ""
        val response = httpClient.get("$baseUrl/encontrarporlocacaoid/$id?page=$page$statusParam") {
            header("Authorization", "Bearer ${getToken()}")
        }
        return response.body()
    }

    suspend fun updateStatus(idPayment: String, statuses: List<StatusInstallmentDTO>): ResponseMessage {
        val response = httpClient.patch("$baseUrl/atualizarstatus/${idPayment}") {
            header("Authorization", "Bearer ${getToken()}")
            contentType(ContentType.Application.Json)
            setBody(statuses)
        }
        if (response.status.isSuccess()) {
            return Ok()
        }
        return response.body<ErrorDTO>()
    }
}